import { t as __t } from "i18next";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { callCmsChangePassword } from "../../../api/settings/service";
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import MenuToggler from "../../../components/common/MenuToggler";
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import { handleInput, handleInvalid, handleGetCookie } from "../../../utils/commonUtil";
import "../../../components/i18n/lang";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

const Index = () => {
	const { t } = useTranslation()
	const [changePassword, setChangePassword] = useState({
		newPassword: "", confirmPassword: "", userId: null, oldPass: ""
	});
	const dispath = useDispatch();

	useEffect(() => {
		const authData = handleGetCookie('auth');
		if (authData?.user?.userId) {
			setChangePassword({
				...changePassword,
				userId: authData?.user?.userId,
			});
		}
	}, []);

	const handleChange = (e) => {
		const { name, value } = e.target;
		setChangePassword({
			...changePassword,
			[name]: value,
		});
	};

	const submitChangePassword = async (event) => {
		event.preventDefault();

		if (changePassword.newPassword !== changePassword.confirmPassword) {
			toast.error(t("changePassword.passwordNotMatch"), {
				position: "top-left"
			})
			return;
		}

		if (changePassword.newPassword.length < 6) {
			toast.error(t("changePassword.passwordLengthError") || __t("uiText.text338"), { position: "top-left" });
			return;
		}

		if (!/[a-zA-Z]/.test(changePassword.newPassword)) {
			toast.error(t("changePassword.passwordCharError") || __t("uiText.text339"), { position: "top-left" });
			return;
		}

		Swal.fire({
			title: t("areYouSure"),
			text: t("confirmChangePassword"),
			icon: "question",
			reverseButtons: true,
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: t("confirm"),
			cancelButtonText: t("cancel")
		}).then(async (result) => {
			if (result.isConfirmed) {
				const res = await dispath(callCmsChangePassword(changePassword));
				console.log(res)
				if (res.payload != undefined && res.payload.responseCode == "00000") {
					Swal.fire({
						icon: "success",
						title: t("success.changePassword"),
						confirmButtonColor: "#3085d6",
						confirmButtonText: t('close'),
					})
					window.location.href = "/logout"
				}
			}
		});

	}


	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<form onSubmit={submitChangePassword}>
				<section className="user-dashboard">
					<div className="dashboard-outer">
						<div className="upper-title-box">
							<h4>{t('menu.setting.changePassword')}!</h4>
						</div>

						<MenuToggler />

						<div className="row">
							<div className="col-lg-12">
								<div className="ls-widget">
									<div className="tabs-box">
										<div className="widget-content p-4">
											<div className="row">
												<div className="form-group col-lg-7 col-md-12 mt-3">
													<label>{t('changePassword.oldPassword')} <span className="text-danger">*</span></label>
													<input type="password"
														name="oldPass"
														className="form-control-uld"
														value={changePassword.oldPass}
														onChange={handleChange}
														onInvalid={(event) => handleInvalid(event, t('changePassword.oldPassword'))}
														onInput={handleInput}
														required />
												</div>

												<div className="form-group col-lg-7 col-md-12 mt-3">
													<label>{t('changePassword.password')} <span className="text-danger">*</span></label>
													<input type="password"
														name="newPassword"
														className="form-control-uld"
														value={changePassword.password}
														onChange={handleChange}
														onInvalid={(event) => handleInvalid(event, t('changePassword.password'))}
														onInput={handleInput}
														required />
												</div>


												<div className="form-group col-lg-7 col-md-12 mt-3">
													<label>{t('changePassword.confirmPassword')} <span className="text-danger">*</span></label>
													<input type="password"
														name="confirmPassword"
														className="form-control-uld"
														value={changePassword.confirmPassword}
														onChange={handleChange}
														onInvalid={(event) => handleInvalid(event, t('changePassword.confirmPassword'))}
														onInput={handleInput}
														required />
												</div>

												<div className="form-group col-lg-6 col-md-12 mt-3">
													<button type="submit" className="theme-btn btn-style-one">
														{t('changePassword.btnSave')}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</form>
			<CopyrightFooter />
		</div>
	);
};

export default Index;
